(function ($) {
    $(function () {
        var blockClass = 'accordion';
        var dot = '.';

        var sectionClass = blockClass + '__section';
        var headingClass = blockClass + '__heading';
        var contentClass = blockClass + '__content';

        var linkClass = blockClass + '__link';
        var iconClass = blockClass + '__icon';

        var sectionClassHidden = sectionClass + '--hidden';
        var iconClassShow = iconClass + '--show';
        var iconClassHide = iconClass + '--hide';

        $(dot + sectionClass).each(function (sectionIndex, sectionNode) {
            var section = $(sectionNode);
            var heading = section.find(dot + headingClass);
            var content = section.find(dot + contentClass);
            var link = $('<a href="#" class="' + linkClass + '">' + heading.text() + '</a>');

            heading.empty().append(link);
            content.hide();
            section.addClass(sectionClassHidden);

            link.append('<span class="' + iconClass + ' ' + iconClassShow + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M17 13h-4v4h-2v-4H7v-2h4V7h2v4h4m-5-9A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2z"/></svg> <span class="screen-reader-text">Show</span></span>');
            link.append('<span class="' + iconClass + ' ' + iconClassHide + '"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M17 13H7v-2h10m-5-9A10 10 0 002 12a10 10 0 0010 10 10 10 0 0010-10A10 10 0 0012 2z"/></svg> <span class="screen-reader-text">Hide</span></span>');

            link.on('click', function (e) {
                e.preventDefault();

                content.slideToggle({
                    complete: function () {
                        section.toggleClass(sectionClassHidden, !content.is(':visible'));
                    }
                });
            });
        });
    });
})(jQuery);
